import { Component, effect, input, signal } from '@angular/core';

@Component({
  selector: 'app-loading-page',
  standalone: true,
  imports: [],
  templateUrl: './loading-page.component.html',
  styleUrls: ['./loading-page.component.scss'],
})
export class LoadingPageComponent {
  readonly title     = input('PARTNER CORE');
  readonly isLoading = input(true);

  protected readonly fadeOut = signal(false);

  constructor() {
    effect(() => {
      this.fadeOut.set(!this.isLoading());
    });
  }
}
